import script from "./SelectLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectLanguage.vue?vue&type=style&index=0&id=19ea0e28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ea0e28"]])

export default __exports__